import { isNova } from '@/config'
import { orderDetailsQueryOptions } from '@/hooks/queries/useOrders'
import { novaOrderDetails } from '@/lib/utils/novaOrders'
import { queryClient } from '@/main'
import { createFileRoute } from '@tanstack/react-router'
import { NovaOrderDetails } from '../-components/NovaOrderDetails'
import { OrderDetails } from '../-components/OrderDetails'
import { mainlineOrderDetails } from '../-components/OrderDetails/orderDetailsShape'

/**
 * The one page too divergent to port in place, so the route picks a whole tree and everything below
 * it is variant-pure and never asks the switch again.
 *
 * The two shapes are different enough that sharing components would mean a union row type and a
 * guard in every card: Nova nests both legs under `legs` with coupling state and per-leg journeys,
 * where mainline has one flat order. The crumb is the only thing both trees need from the loader,
 * and each side narrows the response its own way.
 */
export const Route = createFileRoute('/_auth/_modules/_app/orders/all/$dynamoId/$poNumber')({
  component: Component,
  loader: async ({ params }) => {
    const { dynamoId } = params

    const data = await queryClient.ensureQueryData(orderDetailsQueryOptions(dynamoId))

    if (isNova) {
      const order = novaOrderDetails(data.result)
      const leg = order.legs[order.requestedLeg] ?? order.legs.fmc ?? order.legs.nc

      return {
        crumb: order.customer.sapErp ? `PO# ${leg?.poNumber}` : (leg?.poNumber ?? ''),
      }
    }

    const order = mainlineOrderDetails(data.result)

    return {
      crumb: order.customer.sapErp ? `PO# ${order.poNumber}` : order.poNumber,
    }
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})

function Component() {
  return isNova ? <NovaOrderDetails /> : <OrderDetails />
}
